<template>
    <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="navbar_hoverEffect_second" d="M15.7092 12.5147C15.7092 12.7489 15.7915 12.9757 15.9416 13.1555L15.9417 13.1557L15.9443 13.1588L15.9568 13.1741C15.9624 13.1809 15.9694 13.1894 15.9778 13.1997C15.9868 13.2108 15.9974 13.2239 16.0095 13.239C16.0562 13.2969 16.1245 13.3829 16.2082 13.4919C16.3762 13.7103 16.6039 14.0175 16.8423 14.3716C17.3403 15.1117 17.8043 15.9405 17.9548 16.5706C18.0657 17.0346 17.9703 17.4066 17.6924 17.7651C17.3848 18.1619 16.8301 18.5621 16.0053 18.9153C14.36 19.62 11.9656 20 9.5 20C7.03442 20 4.63999 19.62 2.99471 18.9153C2.16992 18.5621 1.61524 18.1619 1.3076 17.7651C1.02972 17.4066 0.934319 17.0346 1.04515 16.5706C1.19567 15.9405 1.65966 15.1117 2.15775 14.3716C2.39608 14.0175 2.62376 13.7103 2.79175 13.4919C2.87552 13.3829 2.94383 13.2969 2.99045 13.239C3.01374 13.21 3.03157 13.1882 3.04315 13.1741L3.05572 13.1588L3.05829 13.1557C3.05834 13.1557 3.05839 13.1556 3.05843 13.1555C3.20853 12.9757 3.29075 12.7489 3.29075 12.5147V9.20925C3.29075 5.77997 6.07073 3 9.5 3C12.9293 3 15.7092 5.77997 15.7092 9.20925V12.5147Z" stroke-width="2" stroke-linejoin="round"/>
        <path class="navbar_hoverEffect_second" d="M9.5 3L9.5 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="navbar_hoverEffect" d="M11 22.5C11 23 10.323 23.5 9.5 23.5C8.67697 23.5 8 23 8 22.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
  name: 'NotificationIcon'
}
</script>

<style scoped>
path {
    stroke: var(--nav-menu-new-icon);
}
circle {
    stroke: var(--nav-menu-new-icon);
}
rect {
    stroke: var(--nav-menu-new-icon);
}
</style>
